import normalize from 'json-api-normalizer';

import QuestionChoice from './question_choice';

export default class ResultEntryValue {
	static from (jsonapi) {
		let key = 'resultEntryValues'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = ResultEntryValue.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return ResultEntryValue.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		let relationships = {}
		if ('questionChoiceId' in attributes && attributes['questionChoiceId'] && normalizedJSONapi['questionChoices'] && noRelationships == 0) {
			relationships['questionChoice'] = QuestionChoice.make(normalizedJSONapi['questionChoices'][attributes['questionChoiceId']], normalizedJSONapi);
		}

		return new ResultEntryValue ( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, text, value, row, column, questionChoice, questionChoiceId }) {

		this.id              = id ? id : -1;
		this.text            = (text == undefined) ? null : String(text);
		this.value           = (value == undefined) ? null : String(value);
		this.row             = row ? row : null;
		this.column          = column ? column : null;
		this.question_choice = (questionChoice == undefined) ? null : questionChoice;
		this.question_choice_id = questionChoiceId ? questionChoiceId : null;
	}

	toJSONapi () {
		return {data: this.innerJSONapi()}
	}

	innerJSONapi() {
		let attributes = Object.assign({}, this);
		delete attributes.id;
		delete attributes.question_choice;

		return {type: "result_entry_values", id: this.id, attributes}
	}
}
